// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateApiConnectionContainer_FOu4Z {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  textarea {
    resize: none;
    min-height: 50px;
    max-height: 80px;
    width: 100%;
    field-sizing: content;
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    background-color: var(--f4-background);
    border-radius: 5px;
    box-sizing: border-box;
    padding: 8px;
  }
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 100%;
  }
  .step3_p1Ktq {
    align-items: start;
    gap: 10px;
  }

  .nameIconFactura_l4JM6 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .step1Container_sWhfm {
    gap: 20px;
  }

  .IconFacturaGPT_cVq7o {
    width: 100px;
    stroke: var(--_10a37f-background);
  }
  .searchIconsWrappers_MQU5M {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: var(--ececf1-background);
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 3px;
  }

  .noConnection_e0hX7 {
    color: #666666;
  }

  .servicesContainer_A9Mwg {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 15px;
    padding: 10px;
    justify-content: center;
  }

  .servicesContainer_A9Mwg > div {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(20% - 26px); /* 5 por fila en desktop */
    max-width: calc(20% - 26px);
    aspect-ratio: 1 / 1;
    max-height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    box-sizing: border-box;
    padding: 6px;
    color: white;
    font-size: 12px;
    font-weight: bold;
    border: 1px solid #ececf1;
    border-radius: 12px;
    svg {
      height: 90%;
      width: 90%;
    }
  }

  @media (max-width: 1199px) and (min-width: 768px) {
    .servicesContainer_A9Mwg > div {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(25% - 26px); /* 4 por fila */
      max-width: calc(25% - 26px);
      max-height: 80px;
    }
  }

  @media (max-width: 767px) {
    .servicesContainer_A9Mwg > div {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(50% - 26px); /* 2 por fila */
      max-width: calc(50% - 26px);
      max-height: 70px;
      font-size: 11px;
    }
  }

  @media (max-width: 480px) {
    .servicesContainer_A9Mwg > div {
      flex: 0 0 100%; /* 1 por fila */
      max-width: 100%;
      max-height: 60px;
      font-size: 10px;
    }
  }

  .activeService_oScC5 {
    background-color: #ececf1;
  }
}

.labelInput_zkYEm {
  color: var(--_1f184b-color);
  font-size: 13px;
  line-height: 1;
  border-bottom: 0px solid var(--e8-border);
  border-top: 0px solid var(--e8-border);
  margin-top: 0px;
  margin-bottom: 0px;
  margin-bottom: 6px;
  width: 100%;
}

.inputContainer_GRCPk {
  display: flex;
  gap: 8px;
  padding: 5px 16px;
  background: var(--f1-background);
  border-radius: 6px;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  input {
    background-color: transparent;
    outline: none;
    border: none;
  }
}

.inputSearchEnpoints_Ll08A {
  padding: 0px;
  margin: 0px;
  height: 20px;
  border: none;
  outline: none;
  background-color: transparent;
  color: var(--black-color);
  font-size: 14px;
}

.buttonInputSearchEndPoints_aJ1O1 {
  padding: 0px 10px;
  margin: 0px;
  height: 20px;
  /* width: 100%; */
  /* max-width: 160px; */
  border-radius: 8px;
  border: none;
  outline: none;
  background-color: var(--white-background);
  color: #4f5660;
  font-size: 12px;
  cursor: pointer;
  font-weight: 550;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  white-space: nowrap;
}

.apiInfo_RXcDW {
  width: 100%;
}

.noEndpointsFound_Hbnwm {
  width: 100%;
}


.progressBarWrapper_VlF8G {
  width: 100%;
  height: 10px;
  background-color: #e0e0e0; /* gris claro */
  border-radius: 4px;
  overflow: hidden;
  margin: 8px 0;
}

.progressBarFill_dLNW8 {
  width: 45%; /* valor estático por ahora */
  height: 100%;
  background-color: #10A37F; /* verde */
  transition: width 0.3s ease;
  border-radius: 4px;
}

.testApiConnection_obR3y{
  color: #222222;
  font-weight: 500;
  font-size: 17px;
}

.visualizesEndpointStatus_F3BCk{
  font-size: 13px;
}
.selectEndpoint_cm5a_{
  width: 100%;
}

.endpoint_BNRvp{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.endpointInfo_NMWbb{
  display: flex;
  align-items: center;
  gap: 10px;
}

.endpointName_ywMQ_{
  font-weight: 500;
}

.typeEndpoint_DFDKm{
font-size: 13px;
font-weight: 500;
}

.typeEndpointPost_MtLmc{
  color: #0000FF;
}

.rightSection_w5sCY{
  display: flex;
  align-items: center;
  gap: 10px;
  .statusEndpoint_IYzm1{
    background-color: #f6851b0c;
    padding: 6px 16px;
    border-radius: 8px;
    color: #71717A;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  span{
    color: #71717A;
  }
}

.endpointScrapperd_NqxYV{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.headerEndpoint_mj_o3{
  display: flex;
  align-items: center;
  gap: 5px;
  p{
    color: #353A44;
    font-weight: 500;
  }
  span{
    color: #596171;
  }
}

.responseEndpointScrapper_H5mBB{
  color: #8C90A2;
}

.percentageResponse_wf1B3{
  color: #A5A5A5;
}

.describeContainer_GlWJo{
  width: 100%;
  background-color: var(--f4-background);
  border-radius: 12px;
  overflow: hidden;
  padding: 4px;
  box-sizing: border-box;
  min-height: fit-content;
  svg{
    fill: white;
  }
}

.automateStep1Container_vizp3{
  border: 1px solid #ECECF1;
  padding: 8px 16px;
  border-radius: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  p{
    color: #000000;
    font-weight: 400;
  }
  span{
    font-size: 14px;
    color: #666666;
  }
}
.describeContainerStep2_AYm3U{
  svg{
    fill: #10A37F;
  }
}
.iconContainer_Hii38{
  height: 30px;
  width: 30px;
  svg{
    height: 100%;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/CreateApiConnection/CreateApiConnection.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,iCAAiC;EACnC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,SAAS;IACT,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B,EAAE,0BAA0B;IACtD,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB;MACE,WAAW;MACX,UAAU;IACZ;EACF;;EAEA;IACE;MACE,YAA0B;MAA1B,cAA0B;MAA1B,4BAA0B,EAAE,eAAe;MAC3C,2BAA2B;MAC3B,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,YAA0B;MAA1B,cAA0B;MAA1B,4BAA0B,EAAE,eAAe;MAC3C,2BAA2B;MAC3B,gBAAgB;MAChB,eAAe;IACjB;EACF;;EAEA;IACE;MACE,cAAc,EAAE,eAAe;MAC/B,eAAe;MACf,gBAAgB;MAChB,eAAe;IACjB;EACF;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,eAAe;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU,EAAE,6BAA6B;EACzC,YAAY;EACZ,yBAAyB,EAAE,UAAU;EACrC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;AACA,eAAe;AACf,gBAAgB;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB;IACE,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,cAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,YAAY;EACZ,WAAW;EACX;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".CreateApiConnectionContainer {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  textarea {\n    resize: none;\n    min-height: 50px;\n    max-height: 80px;\n    width: 100%;\n    field-sizing: content;\n    border: none;\n    outline: none;\n    font-size: 14px;\n    font-weight: 400;\n    background-color: var(--f4-background);\n    border-radius: 5px;\n    box-sizing: border-box;\n    padding: 8px;\n  }\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n  }\n  .step3 {\n    align-items: start;\n    gap: 10px;\n  }\n\n  .nameIconFactura {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .step1Container {\n    gap: 20px;\n  }\n\n  .IconFacturaGPT {\n    width: 100px;\n    stroke: var(--_10a37f-background);\n  }\n  .searchIconsWrappers {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    background: var(--ececf1-background);\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    border-radius: 3px;\n  }\n\n  .noConnection {\n    color: #666666;\n  }\n\n  .servicesContainer {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    gap: 15px;\n    padding: 10px;\n    justify-content: center;\n  }\n\n  .servicesContainer > div {\n    flex: 0 0 calc(20% - 26px); /* 5 por fila en desktop */\n    max-width: calc(20% - 26px);\n    aspect-ratio: 1 / 1;\n    max-height: 90px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    text-align: center;\n    box-sizing: border-box;\n    padding: 6px;\n    color: white;\n    font-size: 12px;\n    font-weight: bold;\n    border: 1px solid #ececf1;\n    border-radius: 12px;\n    svg {\n      height: 90%;\n      width: 90%;\n    }\n  }\n\n  @media (max-width: 1199px) and (min-width: 768px) {\n    .servicesContainer > div {\n      flex: 0 0 calc(25% - 26px); /* 4 por fila */\n      max-width: calc(25% - 26px);\n      max-height: 80px;\n    }\n  }\n\n  @media (max-width: 767px) {\n    .servicesContainer > div {\n      flex: 0 0 calc(50% - 26px); /* 2 por fila */\n      max-width: calc(50% - 26px);\n      max-height: 70px;\n      font-size: 11px;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .servicesContainer > div {\n      flex: 0 0 100%; /* 1 por fila */\n      max-width: 100%;\n      max-height: 60px;\n      font-size: 10px;\n    }\n  }\n\n  .activeService {\n    background-color: #ececf1;\n  }\n}\n\n.labelInput {\n  color: var(--_1f184b-color);\n  font-size: 13px;\n  line-height: 1;\n  border-bottom: 0px solid var(--e8-border);\n  border-top: 0px solid var(--e8-border);\n  margin-top: 0px;\n  margin-bottom: 0px;\n  margin-bottom: 6px;\n  width: 100%;\n}\n\n.inputContainer {\n  display: flex;\n  gap: 8px;\n  padding: 5px 16px;\n  background: var(--f1-background);\n  border-radius: 6px;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  input {\n    background-color: transparent;\n    outline: none;\n    border: none;\n  }\n}\n\n.inputSearchEnpoints {\n  padding: 0px;\n  margin: 0px;\n  height: 20px;\n  border: none;\n  outline: none;\n  background-color: transparent;\n  color: var(--black-color);\n  font-size: 14px;\n}\n\n.buttonInputSearchEndPoints {\n  padding: 0px 10px;\n  margin: 0px;\n  height: 20px;\n  /* width: 100%; */\n  /* max-width: 160px; */\n  border-radius: 8px;\n  border: none;\n  outline: none;\n  background-color: var(--white-background);\n  color: #4f5660;\n  font-size: 12px;\n  cursor: pointer;\n  font-weight: 550;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.apiInfo {\n  width: 100%;\n}\n\n.noEndpointsFound {\n  width: 100%;\n}\n\n\n.progressBarWrapper {\n  width: 100%;\n  height: 10px;\n  background-color: #e0e0e0; /* gris claro */\n  border-radius: 4px;\n  overflow: hidden;\n  margin: 8px 0;\n}\n\n.progressBarFill {\n  width: 45%; /* valor estático por ahora */\n  height: 100%;\n  background-color: #10A37F; /* verde */\n  transition: width 0.3s ease;\n  border-radius: 4px;\n}\n\n.testApiConnection{\n  color: #222222;\n  font-weight: 500;\n  font-size: 17px;\n}\n\n.visualizesEndpointStatus{\n  font-size: 13px;\n}\n.selectEndpoint{\n  width: 100%;\n}\n\n.endpoint{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n.endpointInfo{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.endpointName{\n  font-weight: 500;\n}\n\n.typeEndpoint{\nfont-size: 13px;\nfont-weight: 500;\n}\n\n.typeEndpointPost{\n  color: #0000FF;\n}\n\n.rightSection{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  .statusEndpoint{\n    background-color: #f6851b0c;\n    padding: 6px 16px;\n    border-radius: 8px;\n    color: #71717A;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  span{\n    color: #71717A;\n  }\n}\n\n.endpointScrapperd{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.headerEndpoint{\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  p{\n    color: #353A44;\n    font-weight: 500;\n  }\n  span{\n    color: #596171;\n  }\n}\n\n.responseEndpointScrapper{\n  color: #8C90A2;\n}\n\n.percentageResponse{\n  color: #A5A5A5;\n}\n\n.describeContainer{\n  width: 100%;\n  background-color: var(--f4-background);\n  border-radius: 12px;\n  overflow: hidden;\n  padding: 4px;\n  box-sizing: border-box;\n  min-height: fit-content;\n  svg{\n    fill: white;\n  }\n}\n\n.automateStep1Container{\n  border: 1px solid #ECECF1;\n  padding: 8px 16px;\n  border-radius: 8px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 10px;\n  p{\n    color: #000000;\n    font-weight: 400;\n  }\n  span{\n    font-size: 14px;\n    color: #666666;\n  }\n}\n.describeContainerStep2{\n  svg{\n    fill: #10A37F;\n  }\n}\n.iconContainer{\n  height: 30px;\n  width: 30px;\n  svg{\n    height: 100%;\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CreateApiConnectionContainer": `CreateApiConnectionContainer_FOu4Z`,
	"step3": `step3_p1Ktq`,
	"nameIconFactura": `nameIconFactura_l4JM6`,
	"step1Container": `step1Container_sWhfm`,
	"IconFacturaGPT": `IconFacturaGPT_cVq7o`,
	"searchIconsWrappers": `searchIconsWrappers_MQU5M`,
	"noConnection": `noConnection_e0hX7`,
	"servicesContainer": `servicesContainer_A9Mwg`,
	"activeService": `activeService_oScC5`,
	"labelInput": `labelInput_zkYEm`,
	"inputContainer": `inputContainer_GRCPk`,
	"inputSearchEnpoints": `inputSearchEnpoints_Ll08A`,
	"buttonInputSearchEndPoints": `buttonInputSearchEndPoints_aJ1O1`,
	"apiInfo": `apiInfo_RXcDW`,
	"noEndpointsFound": `noEndpointsFound_Hbnwm`,
	"progressBarWrapper": `progressBarWrapper_VlF8G`,
	"progressBarFill": `progressBarFill_dLNW8`,
	"testApiConnection": `testApiConnection_obR3y`,
	"visualizesEndpointStatus": `visualizesEndpointStatus_F3BCk`,
	"selectEndpoint": `selectEndpoint_cm5a_`,
	"endpoint": `endpoint_BNRvp`,
	"endpointInfo": `endpointInfo_NMWbb`,
	"endpointName": `endpointName_ywMQ_`,
	"typeEndpoint": `typeEndpoint_DFDKm`,
	"typeEndpointPost": `typeEndpointPost_MtLmc`,
	"rightSection": `rightSection_w5sCY`,
	"statusEndpoint": `statusEndpoint_IYzm1`,
	"endpointScrapperd": `endpointScrapperd_NqxYV`,
	"headerEndpoint": `headerEndpoint_mj_o3`,
	"responseEndpointScrapper": `responseEndpointScrapper_H5mBB`,
	"percentageResponse": `percentageResponse_wf1B3`,
	"describeContainer": `describeContainer_GlWJo`,
	"automateStep1Container": `automateStep1Container_vizp3`,
	"describeContainerStep2": `describeContainerStep2_AYm3U`,
	"iconContainer": `iconContainer_Hii38`
};
export default ___CSS_LOADER_EXPORT___;
